var _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTaelys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "185px",
    height: "50px",
    viewBox: "0 0 185 50",
    style: {
      enableBackground: "new 0 0 185 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_xA9_Taelys"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.849,20.665v21.109h-4.448V20.665H71.43v-3.951h20.75v3.951H83.849z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.771,39.943c-0.388,0.639-1.063,1.161-2.027,1.565c-0.964,0.405-1.97,0.607-3.02,0.607 c-1.973,0-3.523-0.493-4.653-1.48c-1.129-0.986-1.693-2.386-1.693-4.199c0-2.121,0.795-3.781,2.386-4.978s3.852-1.796,6.783-1.796 c0.501,0,1.095,0.085,1.779,0.256c0-2.155-1.363-3.233-4.088-3.233c-1.608,0-2.954,0.268-4.037,0.804l-0.924-3.318 c1.471-0.707,3.222-1.061,5.251-1.061c2.794,0,4.841,0.636,6.141,1.907c1.3,1.272,1.95,3.681,1.95,7.228v3.917 c0,2.44,0.49,3.975,1.471,4.602c-0.354,0.616-0.747,0.995-1.18,1.138c-0.434,0.143-0.93,0.214-1.488,0.214 c-0.616,0-1.169-0.229-1.659-0.685S103.941,40.479,103.771,39.943z M103.36,33.152c-0.73-0.148-1.277-0.222-1.642-0.222 c-3.375,0-5.063,1.106-5.063,3.318c0,1.643,0.952,2.463,2.857,2.463c2.566,0,3.849-1.283,3.849-3.849V33.152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.219,33.922h-13.086c0.08,1.46,0.582,2.594,1.505,3.404c0.923,0.81,2.167,1.215,3.729,1.215 c1.95,0,3.432-0.507,4.447-1.522l1.66,3.267c-1.505,1.221-3.752,1.831-6.74,1.831c-2.794,0-5.004-0.818-6.629-2.455 c-1.625-1.636-2.438-3.92-2.438-6.851c0-2.885,0.892-5.223,2.677-7.014c1.785-1.79,3.926-2.686,6.423-2.686 c2.657,0,4.79,0.793,6.397,2.378s2.412,3.604,2.412,6.055C131.578,32.069,131.458,32.861,131.219,33.922z M118.287,30.706h8.998 c-0.296-2.68-1.779-4.02-4.447-4.02C120.396,26.686,118.879,28.026,118.287,30.706z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.362,16.627l4.276-1.026v20.595c0,2.258,0.673,3.604,2.019,4.037c-0.662,1.254-1.791,1.882-3.387,1.882 c-1.938,0-2.908-1.346-2.908-4.037V16.627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.694,44.716c-0.456,1.22-1.434,2.232-2.934,3.036s-3.248,1.206-5.243,1.206v-3.78c3.296,0,4.944-0.827,4.944-2.48 c0-1.095-0.457-2.771-1.369-5.029l-5.73-14.215h4.431l4.995,12.658l4.499-12.658h4.431L158.694,44.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.781,40.593l1.522-3.404c1.277,1.015,2.72,1.522,4.328,1.522c1.665,0,2.497-0.593,2.497-1.779 c0-0.696-0.251-1.266-0.752-1.711c-0.502-0.444-1.477-0.969-2.925-1.574c-3.159-1.311-4.738-3.147-4.738-5.508 c0-1.585,0.604-2.82,1.813-3.704c1.208-0.884,2.754-1.326,4.636-1.326c1.904,0,3.695,0.428,5.371,1.283l-1.231,3.319 c-0.936-0.798-2.235-1.197-3.9-1.197c-1.494,0-2.241,0.593-2.241,1.779c0,0.468,0.245,0.89,0.735,1.266 c0.49,0.376,1.54,0.881,3.147,1.514s2.766,1.4,3.473,2.301s1.061,1.99,1.061,3.267c0,1.699-0.63,3.036-1.89,4.011 c-1.26,0.975-2.974,1.463-5.141,1.463c-1.22,0-2.198-0.1-2.934-0.299C172.877,41.617,171.933,41.209,170.781,40.593z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#002C54",
      strokeWidth: 0.5266,
      strokeMiterlimit: 10
    },
    d: "M32.79,43.541 c0.022,0.011,0.048,0.017,0.074,0.022"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6436,
    y1: 40.5176,
    x2: 11.3135,
    y2: 20.1613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16A4F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00146B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M5.432,28.724c5.101,6.667,15.225,12.002,27.932,14.734 c-13.57-2.944-23.501-12.46-23.501-23.734c0-0.689,0.05-1.369,0.123-2.043C5.11,22.802,5.432,28.724,5.432,28.724z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.125,22.904c-2.499,0-4.529,2.023-4.529,4.527c0,2.498,2.03,4.528,4.529,4.528c2.505,0,4.528-2.03,4.528-4.528 C48.652,24.927,46.629,22.904,44.125,22.904z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.5186,
    y1: 28.5693,
    x2: 38.9755,
    y2: 7.4174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16A4F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00146B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M30.68,1c-3.762,0-7.387,0.458-10.783,1.307C10.355,4.682,2,10.433,2,19.169 c0,3.485,1.282,6.809,3.62,9.858C3.816,12.887,22.985,4.239,35.8,4.365c10.549,0.104,19.836,4.112,25.259,10.354 C55.172,6.54,43.779,1,30.68,1z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTaelys);
export default __webpack_public_path__ + "static/media/logo-taelys.5d712eb5a1ab7e40fa8f4f4d63d323ef.svg";
export { ForwardRef as ReactComponent };